import React from 'react'

const Loading = ({ brand, isLoading }) => {
	switch (brand) {
		case 'lexus':
			return (
				<div className={`ui-loader ${!isLoading ? 'd-none' : ''}`}>
					<div className="ui-loader__icon">
						<div></div>
					</div>
				</div>
			)
		default:
			return (
				<div className={`loading ${!isLoading ? 'd-none' : ''}`}>
					<div className="hidden">Loading..</div>
				</div>
			)
	}
}

export default Loading
